module.exports = __webpack_public_path__ + "img/SC_title.5d33b0dd.png";